import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

// Die importierten Services

// Die importierten Interfaces/Datenmodels
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css']
})

export class ContactFormComponent
  implements OnChanges {

  @Input()
  public number: any = null;

  @Input()
  public address: any = null;

  @Input()
  public contactForm: FormGroup = null;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['address'] || changes['number']) {
      if (this.address !== null && this.number !== null) {
        this.setFormData();
      }
    }
  }

  /**
   * Funktion zum Setzen der Addressdaten im Formular
   */
  private setFormData = () => {
    this.contactForm.patchValue({
      Address: this.address.Address,
      Number: this.number.Number
    });
  }

}
